import { Directive, TemplateRef, ViewContainerRef, inject } from "@angular/core";
import { CdkPortal } from "@angular/cdk/portal";

@Directive({ selector: "[inlineRowTemplate]ng-template" })
export class InlineRowTemplateDirective extends CdkPortal {
   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}
